module.exports = __webpack_public_path__ + "img/source03_m5.ed57c556.png";